import { Alert, AlertTitle, Typography } from '@mui/material'
import { addDays, parse } from 'date-fns/esm'

import { useCreateFormatDate } from '@/hooks'

import { FormattedMessage } from 'react-intl'
import { useTexts } from '../hooks/useTexts'

interface Props {
  lastRecurrenceSuccess?: string
}

export function RecurrentOrdersQueueAlert(props: Props) {
  const { lastRecurrenceSuccess } = props
  const formatDate = useCreateFormatDate()
  const texts = useTexts()

  const firstDayToRestore = lastRecurrenceSuccess
    ? addDays(parse(lastRecurrenceSuccess, 'yyyyMMdd', new Date()), 1)
    : undefined

  return (
    <Alert severity="error" data-testid="recurrent-orders-queue-alert">
      <AlertTitle>{texts.recurrentOrdersQueueAlertTitle}</AlertTitle>
      <FormattedMessage
        id={texts.recurrentOrdersQueueAlertContentId}
        values={{
          date: firstDayToRestore ? formatDate(firstDayToRestore, true) : '',
          b: chunks => (
            <Typography component="span" variant="body2" fontWeight="bold" display="inline">
              {chunks}
            </Typography>
          ),
          br: <br />,
        }}
      />
    </Alert>
  )
}
